'use client';

import { Theme, createTheme } from '@mui/material/styles';

import { Breakpoints } from '@/common/theme/constants';
import { componentOverrides } from '@/common/theme/overrides';
import { palette } from '@/common/theme/palette';
import { typography } from '@/common/theme/typography';

export interface ThemeProps {
  theme?: Theme;
}

export const theme = createTheme({
  breakpoints: {
    values: Breakpoints,
  },
  palette,
  typography,
  components: componentOverrides,
});
